<template lang="html">
	<router-link v-if="routerTo" ref="link" v-bind="$attrs" :to="to" :class="classes" @click="$emit('click', $event)">
		<slot></slot>
	</router-link>
	<a
		v-else-if="isAnchor"
		ref="anchor"
		v-bind="$attrs"
		:href="href"
		:class="classes"
		:target="target"
		@click="$emit('click', $event)"
	>
		<slot></slot>
	</a>
	<button v-else ref="button" v-bind="$attrs" :type="buttonType" :class="classes" @click="$emit('click', $event)">
		<slot></slot>
	</button>
</template>

<script lang="js">
import isObject from 'lodash/isObject'

export default  {
	props : {
		type : {
			type    : String,
			default : 'primary',
		},
		color : {
			type    : String,
			default : '',
		},
		size : {
			type    : String,
			default : 'small',
		},
		isLink : {
			type    : Boolean,
			default : null,
		},
		linkStyle : {
			type    : Boolean,
			default : false,
		},
		href : {
			type    : String,
			default : '',
		},
		target : {
			type    : String,
			default : '',
		},
		buttonType : {
			type    : String,
			default : 'button',
		},
		buttonClass : {
			type    : String,
			default : '',
		},
		arrow : {
			type    : Boolean,
			default : false,
		},
		routerTo : {
			type    : [ String, Object ],
			default : '',
		},
	},
	computed : {
		isAnchor () {
			return null !== this.isLink ? this.isLink : (this.target && this.href)
		},
		classes () {
			const classes = {
				[this.buttonClass]       : Boolean(this.buttonClass),
				'omapi-link-arrow-after' : this.arrow,
			}

			if (this.linkStyle) {
				classes['omapi-button__link'] = true
				return classes
			}

			classes['omapi-button'] = true
			classes[`omapi-button__${this.type}`] = true
			classes[`omapi-button__${this.size}`] = true
			if (this.color) {
				classes[`omapi-button__${this.color}`] = true
			}

			return classes
		},
		to () {
			if (!this.routerTo) {
				return ''
			}

			return isObject(this.routerTo)
				? this.routerTo
				: { name: this.routerTo }
		},
	},
};
</script>
